export const CURRENCY = "$";
export var recordsLimit = 10;

// permission route
export const permissionRoute = {
  "/cms": "cms-management",
  "/role-management": "role-management",
  "/orders": "order-management",
  "/user-management": "user-management",
  "/analytics-report": "report-management",
  "/staff-management": "staff-management",
  "/products": "product-management",
  "/promotion": "promotion-code-management",
  "/voucher": "voucher-management",
  "/promotion-vouchers": ["promotion-code-management", "voucher-management"],
};
export const notProtectedRoute = ["/login", "/", "/settings", "/notifications"];

export const USER_ROLES = {
  ARTIST: "artist",
  USER: "user",
};
export const USER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "system-deactivated",
  INCOMPLETE_PROFILE: "incomplete-profile",
};
export const VIDEO_QUALITY = {
  HD: "hd",
  FHD: "fhd",
  _2K: "2k",
  _4K: "4k",
};
export const ART_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
};
